import TableViewsSelector from "./TableViews";

export default TableViewsSelector;